import { forEach, isNil, sortBy } from "lodash";

import type { ISchedule } from "./ISchedule";
import { DayType } from "./DayType";

export class ScheduleFunctions {
    public static enhanceSchedule(schedule: ISchedule) {
        if (!isNil(schedule.temporaryWeeklySchedule)) {
            forEach(schedule.temporaryWeeklySchedule.daySchedules, (daySchedule) => {
                daySchedule.dayType = DayType[daySchedule.dayType as unknown as keyof typeof DayType];
            });
        }

        if (!isNil(schedule.weeklySchedule)) {
            forEach(schedule.weeklySchedule.daySchedules, (daySchedule) => {
                daySchedule.dayType = DayType[daySchedule.dayType as any as keyof typeof DayType];

                forEach(daySchedule.scheduleTimePeriods, (scheduleTimePeriod) => {
                    scheduleTimePeriod.day = DayType[scheduleTimePeriod.day as any as keyof typeof DayType];
                });
            });
        }

        forEach(schedule.holidayConfigurations, (holidayConfiguration) => {
            forEach(holidayConfiguration.daySchedules, (daySchedule) => {
                daySchedule.dayType = DayType[daySchedule.dayType as any as keyof typeof DayType];
            });

            holidayConfiguration.daySchedules = sortBy(holidayConfiguration.daySchedules, ["dayType"]);
        });
    }
}
